<template>
  <div id="header">
    <div :class="$mq ==='mobile' ? 'wrapper' : ''">
      <div :class="$mq ==='mobile' ? 'line' : ''">
        <div class="languages" :class="$mq !== 'mobile' ? 'container' : ''">
          <div class="border inline right">
            <span class="language" @click="switchLocale()">{{ locale }}</span>
          </div>
        </div>

        <div
          class="nav inline space-between"
          :class="$mq !== 'mobile' ? 'container left' : 'space-between'"
        >
          <a href="https://mega.be">
            <img src="@/assets/logoMegaHeader.svg" />
          </a>
        </div>
      </div>
    </div>

    <div class="banner" v-if="$mq !== 'mobile'">
      <div :class="$mq !== 'mobile' ? 'container' : ''">
        <h1 v-html="$t('title')"></h1>
      </div>
    </div>

    <div class="subtitle" :class="$mq !== 'mobile' ? 'container' : ''" v-if="$mq !== 'mobile'">
      <h2>{{ $t(`subtitles.${subtitle}.title`) }}</h2>
      <p>{{ $t(`subtitles.${subtitle}.text`, [this.$store.state.comparison.economyText]) }}</p>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      mobileMenu: false
    };
  },
  computed: {
  ...mapState("common", ["lang"]),
    subtitle() {
      let subtitle = "estimation";

      if (this.$route.name === "Simulation") subtitle = "simulation";
      if (this.$route.name === "Comparison") subtitle = "comparison";

      return subtitle;
    },
    locale() {
      return this.$i18n.locale === "fr" ? "NL" : "FR";
    }
  },
  methods: {
    switchLocale() {
      if (this.$i18n.locale === "fr") {
        this.$i18n.locale = "nl";
        this.$store.commit("common/setLang", "nl");
      } else {
        this.$i18n.locale = "fr";
        this.$store.commit("common/setLang", "fr");
      }

      this.$store.dispatch("contact/getCivilities", this.$i18n.locale);
    }
  }
};
</script>

<style lang="scss">
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.languages {
  color: #59666f;
  background: white;
  .border {
    min-height: 40px;
    padding-top: 1px;
    padding-bottom: 2px;
    margin: 0 13px;
    border-bottom: 2px solid #f6f7f8;
  }
}
.language {
  font-size: 0.91rem;
  font-weight: 400;
  padding: 12px 15px;
  transition: all 0.3s;

  &:hover {
    background: #fdcb47;
    color: #59666f;
  }
}

.nav {
  // margin: 0 13%;
  background: white;

  img {
    padding: 17px 14px;
    height: 56px;
  }
}

.banner {
  min-height: 215px;
  color: #231f20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background: url("../assets/header_check.png") repeat-x bottom, #fcc648;

  h1 {
    margin: 15px;
    width: 100%;
    text-align: left;
    font-size: 3.4rem;
    font-weight: 600;
  }

  h2 {
    margin: 0;
    font-size: 1.9rem;
  }
}

.wrapper {
  height: 120px;
  background: white;

  .fixed {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    background: white;
    border-bottom: 1px solid #fcc648;
  }

  .line {
    border-bottom: 1px solid #fcc648;
  }

  .icon-menu {
    margin-right: 10px;
    font-size: 1.8rem;
    color: #fdcb47;
  }
}

.mobile-menu {
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  background: white;
  z-index: 3;

  ul {
    list-style: none;
    margin: 20px 0;
    padding: 0;

    li {
      margin: 10px 0;
      color: #fdcb47;
    }
  }
}

.subtitle {
  text-align: left;

  h2 {
    padding: 0;
    margin: 0;
    margin-top: 20px;
    margin-left: 15px;
    font-weight: 600;
    font-size: 1.3rem;
  }

  p {
    font-size: 0.9rem;
    margin: 10px 0;
    margin-left: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue